import { makeStyle } from '../../../../utils';
import { blackOutline, subTitle1, blackHigh, overline, blackMedium } from '../../../../resources/styles';

const styles = {};

styles['container'] = makeStyle({
    height: '100%',
    borderRight: `1px solid ${blackOutline.color}`,
});

styles['header'] = makeStyle({
    padding: '0 2px 0 15px',
    height: 56,
    display: 'flex',
    alignItems: 'center',
    borderBottom: `1px solid ${blackOutline.color}`,
}, { display: 'none' });

styles['left_divider'] = makeStyle({
    backgroundColor: blackOutline.color,
    width: 1, height: 16,
    margin: '0 8px',
});

styles['owner_portal'] = makeStyle({
    ...overline,
    letterSpacing: '0.4px',
    ...blackMedium,
    flex: 1,
});

styles['item_wrapper'] = makeStyle({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    height: 56,
    borderLeft: '4px solid transparent',
    ...blackHigh
});

styles['item'] = makeStyle({
    display:'flex'
});

styles['item_active'] = makeStyle({
    borderLeftColor: 'var(--theme-color)',
    backgroundColor: 'var(--theme-color-light)',
    color: 'var(--theme-color)',
});

styles['item_icon'] = makeStyle({
    margin: '0 18px',
})

styles['item_label'] = makeStyle({
    ...subTitle1, paddingRight: 24,
});

export default styles;